"use strict";
// No top-level node:async_hooks / node:crypto imports — this module is
// reachable from the client/edge bundle (via the logger). AsyncLocalStorage
// is Node-only (loaded lazily); randomUUID comes from the Web Crypto global
// which exists in Node 19+, Edge and browsers.
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTrace = withTrace;
exports.runWithTrace = runWithTrace;
exports.currentTraceId = currentTraceId;
exports.traceIdOrNew = traceIdOrNew;
let _storage;
function getStorage() {
    if (_storage !== undefined)
        return _storage;
    const isNode = typeof process !== 'undefined'
        && !!process.versions?.node
        && process.env.NEXT_RUNTIME !== 'edge';
    if (!isNode)
        return (_storage = null);
    try {
        // Load node:async_hooks WITHOUT static require or eval (both rejected by the
        // Edge build even though this branch is Node-only). Node 22.3+ exposes
        // process.getBuiltinModule; missing → tracing no-ops.
        //
        // Reach it via globalThis + BRACKET access (not `process.getBuiltinModule`):
        // turbopack's Edge static-analyzer flags the literal `process.getBuiltinModule`
        // member access as an unsupported Node API (even in this Node-guarded branch),
        // emitting a build warning. Indirecting through globalThis with a computed key
        // it can't statically resolve avoids the false Edge-API flag.
        const nodeProcess = globalThis['process'];
        const key = 'getBuiltinModule';
        const getBuiltinModule = nodeProcess?.[key];
        const mod = getBuiltinModule?.('node:async_hooks');
        if (!mod)
            return (_storage = null);
        _storage = new mod.AsyncLocalStorage();
    }
    catch {
        _storage = null;
    }
    return _storage ?? null;
}
function safeUuid() {
    try {
        const c = globalThis.crypto;
        if (c?.randomUUID)
            return c.randomUUID();
    }
    catch { /* fall through */ }
    return `t-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
/** Run `fn` within a trace scope so every log line and enqueued job inside
 *  it shares one trace id. No-op wrapper (just runs `fn`) outside Node.
 *
 *  Legacy signature `(fn, traceId?)` — kept for existing callers. Prefer the
 *  canonical `runWithTrace(traceId, fn)` below for new code. */
function withTrace(fn, traceId = safeUuid()) {
    const s = getStorage();
    return s ? s.run({ traceId }, fn) : fn();
}
/** Canonical trace-scope runner: `runWithTrace(traceId, fn)`. Every log line
 *  and enqueued job inside `fn` shares `traceId`. No-op wrapper outside Node. */
function runWithTrace(traceId, fn) {
    return withTrace(fn, traceId);
}
/** Current trace id if inside a scope, else undefined. */
function currentTraceId() {
    return getStorage()?.getStore()?.traceId;
}
/** Current trace id, or a fresh one (used at enqueue time to stamp jobs). */
function traceIdOrNew() {
    return getStorage()?.getStore()?.traceId ?? safeUuid();
}
